import React, { useEffect, useState } from "react";
import SubscriptionList from "../components/Cards/SubscriptionList";
import BannerImage from "../components/BannerImage";
import BranchList from "../components/BranchList";
import FreeWash from "../components/FreeWash";
import SubscriptionDetails from "../components/SubscriptionDetails";
import ProfessionalFooter from "../components/Footer";
import CarWashFeatures from "../components/Features";

const Home = () => {
  const [isShowSubDetails, setisShowSubDetails] = useState(false);
  const [subscription, setSubsciption] = useState([]);
  const handleSetSub = (subscription) => {
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    setSubsciption(subscription);
    setisShowSubDetails(true);
  };

  useEffect(() => {
    const stored = localStorage.getItem("selectedSubscription");
    if (stored) {
      const parsed = JSON.parse(stored);
      setSubsciption(parsed);
      setisShowSubDetails(true);
      localStorage.removeItem("selectedSubscription");
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-start min-h-screen mb-20 ">
      {isShowSubDetails ? (
        <SubscriptionDetails
          isShowSubDetails={isShowSubDetails}
          subscription={subscription}
          onHide={() => setisShowSubDetails(false)}
        />
      ) : (
        <>
          <BannerImage />
          <CarWashFeatures />
          <FreeWash />
          <SubscriptionList ChooseSubsciption={handleSetSub} />
          <BranchList />
          <ProfessionalFooter />
        </>
      )}
    </div>
  );
};

export default Home;
